import { createSelector } from 'reselect';
import { RootState } from 'reducers/index';
import type { FavoriteCardSuitesByCardType, FilterCardType } from 'favorites/types';
import { FILTER_TYPE_ALL } from 'paper/utils/constants';
import type { FavoritesReducerState } from './reducer';

const getFavoritesState = (state: RootState): FavoritesReducerState => state.favorites;

const getFavoritesPaperState = createSelector(
  [getFavoritesState],
  favoritesState => favoritesState.paper
);

export const getAreFavoritesLoaded = createSelector(
  [getFavoritesPaperState],
  favoritesPaperState => favoritesPaperState.loaded
);

export const getFavoriteCardSuiteUUIDs = createSelector(
  [getFavoritesPaperState],
  favoritesPaperState => favoritesPaperState.uuids
);

export const getFavoriteCardSuites = createSelector(
  [getFavoritesPaperState],
  favoritesPaperState => favoritesPaperState.suites
);

export const getFavoriteCardSuitesByCardType = createSelector(
  [getFavoriteCardSuites],
  (allCardSuites): FavoriteCardSuitesByCardType => {
    const suitesByCardType: FavoriteCardSuitesByCardType = {
      [FILTER_TYPE_ALL]: allCardSuites,
    };

    return allCardSuites.reduce((acc, currentSuite) => {
      const cardType = currentSuite.type as FilterCardType;
      const isDigital = currentSuite.medium === 'DIGITAL';

      // If no card type is defined, ignore this suite
      if (!cardType) return acc;

      if (isDigital && acc.DIGITAL_SAVE_THE_DATE) {
        acc.DIGITAL_SAVE_THE_DATE?.push(currentSuite);
        return acc;
      }

      if (isDigital) {
        return {
          ...acc,
          DIGITAL_SAVE_THE_DATE: [currentSuite],
        };
      }

      // If there is already an array for the current card type, add the current suite to it.
      if (acc[cardType]) {
        acc[cardType]?.push(currentSuite);
        return acc;
      }

      // Otherwise, create a new array for the current card type
      return {
        ...acc,
        [cardType]: [currentSuite],
      };
    }, suitesByCardType);
  }
);
